import { CreateKeywordRequestData, Keyword, KeywordFormData, UpdateKeywordRequestData } from "../types";

export function buildFormData(data?: Keyword): KeywordFormData {
  return {
    id: data?.id || "",
    name: data?.name || "",
  };
}

export function buildRequestData(data: KeywordFormData): CreateKeywordRequestData | UpdateKeywordRequestData {
  return {
    name: data.name,
  };
}
